import { useEffect, useState } from 'react';

export default function useDateTimeCount(currentDate, endDate) {
  const [timeLeft, setTimeLeft] = useState(null);
  const [targetDate, setTargetDate] = useState(new Date(endDate + 'T23:59:59')); // Initial target date
  const [offerExtendedDate, setOfferExtendedDate] = useState(false); // extended Date

  useEffect(() => {
    // Function to calculate the time left
    const calculateTimeLeft = () => {
      // const nowDate = new Date();
      const difference = targetDate - new Date(currentDate);

      // If the target date has passed
      if (difference <= 0) {
        setTimeLeft(null); // Handle as you wish, e.g., "Expired"
        // If the target date has passed, extend by 6 hours
        // setTimeout(() => {
        //   setOfferExtendedDate(true);
        //   setTargetDate(new Date('2025-01-21T00:00:00')); // Add extended date
        // }, 21600000); // 21600000 millisecond after 6 hours to show extended date
        return;
      }

      // If less than 24 hours left, show timer
      // if (difference <= 86400000) {
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(difference / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      // Format hours, minutes, and seconds with leading zeros
      const formattedHours = String(hours).padStart(2, '0');
      const formattedMinutes = String(minutes).padStart(2, '0');
      const formattedSeconds = String(seconds).padStart(2, '0');
      // console.log(
      //   'difference',
      //   days,
      //   parseInt(hours % 24),
      //   // parseInt(formattedHours % 24),
      //   formattedMinutes,
      //   // targetDate,
      //   formattedSeconds
      // );

      setTimeLeft({
        type: 'timer',
        days: days,
        hours: parseInt(hours % 24),
        minutes: formattedMinutes,
        seconds: formattedSeconds,
      });
      // console.log('{ timeLeft, offerExtendedDate }', {
      //   type: 'timer',
      //   days: days,
      //   hours: parseInt(hours / 24),
      //   minutes: formattedMinutes,
      //   seconds: formattedSeconds,
      // });
      // } else {
      //   // Show remaining days
      //   const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      //   setTimeLeft({ type: 'timer', days });
      // }
    };

    calculateTimeLeft();

    const intervalId = setInterval(calculateTimeLeft, 1000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [targetDate, currentDate, offerExtendedDate]); // Update when the targetDate or currentDate changes

  return { timeLeft, offerExtendedDate };
}
